const translations = {
    deleteConfirmationTitle: 'Are you sure you want to delete this invitation?',
    invite: 'Invite',
    inviteUser: 'Invite User',
    notEnoughSeatsError: 'Upgrade your subscription to add more users, all seats are occupied.',
    numberOfSeats: 'Number of Seats: {{seats}}'
};

export default translations;
